/* eslint-disable @nx/enforce-module-boundaries */
import { RankingQuestionConfig } from '@hyper-inferno/click-to-rank-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  BaseComposedElement,
  QuestionAnswerObject,
  QuestionType,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class ClickToRankHandler
  implements QuestionHandler<RankingQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }
  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    // Regex: Starts with el.name, followed by _, ends with one or more digits
    const pattern = new RegExp(`^${el.name}_(\\d+)$`);

    return Object.keys(response)
      .filter(
        (key) =>
          pattern.test(key) &&
          typeof response[key] === 'number' &&
          response[key] >= 1,
      )
      .map((key) => {
        const match = key.match(pattern);
        // Now match[1] will contain the digit suffix
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((suffix): suffix is number => suffix !== null);
  }

  handleAutoCode(
    el: SurveyElement,
    ctx: ITransformationContext,
    composedElement: BaseComposedElement,
  ): QuestionAnswerObject | null {
    // Replace this key with the actual ranking composed-element type/key
    // exported by click-to-rank-core.
    const config = (composedElement as any)[QuestionType.CLICK_TO_RANK] as
      | RankingQuestionConfig
      | undefined;

    if (!config) return null;

    const options = config.options ?? [];

    const selectableOptions = options.filter(
      (option) => !option.is_afm_trigger && !option.hidden && !option.disabled,
    );

    // No available options.
    if (selectableOptions.length === 0) {
      return {};
    }

    // A single available option is automatically ranked first.
    if (selectableOptions.length === 1) {
      const onlyOption = selectableOptions[0];

      if (onlyOption.is_open_ended) {
        return null;
      }

      return {
        [`${el.name}_${onlyOption.option_key}`]: 1,
      };
    }

    // Multiple options require the respondent to rank them.
    return null;
  }
}
